export const isCustomZodMessage = (str: string) => {
  const r = new RegExp('^(custom)')
  return r.test(str)
}

export const getZodMessage = (str: string, translateStr: string) => {
  return isCustomZodMessage(str) ? translateStr : str
}
